import script from "./SuccessMark.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessMark.vue?vue&type=script&setup=true&lang=js"

import "./SuccessMark.vue?vue&type=style&index=0&id=29ce0ac5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ce0ac5"]])

export default __exports__